export const login_success = "login_success";
export const login_failure = "login_failure";
export const signup_success = "signup_success";
export const signup_failure = "signup_failure";
export const nameSearch = "name_Search";
export const locationSearch = "location_Search";
export const gaperIdSearch = "gaperID_Search";
export const skillsSearch = "skills_Search";
export const emailSearch = "email_Search";
export const topFiveProfiles = "topFiveProfiles";
export const client_notifications = "client_notifications";
export const update_client_profiles = "update_client_profiles";
export const get_client = "get_client";
export const get_public_clients = "get_public_clients";
export const get_client_profiles_details = "get_client_profiles_details";
export const CREATE_BOARD = "CREATE_BOARD";
export const UPDATE_BOARD = "UPDATE_BOARD";
export const GET_ALL_BOARDS = "GET_ALL_BOARDS";
export const GET_ALL_CLIENT_BOARDS = "GET_ALL_CLIENT_BOARDS";
export const DELETE_BOARD = "DELETE_BOARD";
export const SHARED_BOARD_EMAILS = "SHARED_BOARD_EMAILS";